import { render, staticRenderFns } from "./ProductionTaskList.vue?vue&type=template&id=e65b8838&"
import script from "./ProductionTaskList.vue?vue&type=script&lang=js&"
export * from "./ProductionTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports